export let policyTabs = [
  {
    label: '售后政策',
    value: 'afterSales'
  },
  {
    label: '运费规则',
    value: 'carriage'
  },
  {
    label: '隐私条款',
    value: 'privacy'
  }
]
export let policyTableLabel = [
  {
    label: '政策名称',
    value: 'name'
  },
  {
    label: '政策类型',
    value: 'type'
  },
  {
    label: '创建时间',
    value: 'created_date'
  }
]
